import * as React from 'react';
import styled from '../../../styled';
import { shadeAlternate } from '../../../styled/helpers';
import { FaPlus } from 'react-icons/fa';
const Wrapper = styled('div') `
  // height: 86vh;
  // overflow-y: auto;
`;
const ItemComponent = styled('div') `
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 12px 15px;
  color: ${({ theme }) => theme.box.text};
  transition: 0.23s all;
  font-weight: 500;
  font-size: ${({ theme }) => theme.font.size}px;

  > .check-circle {
    transition: 0.23s all;
    border: 2px solid ${({ theme }) => shadeAlternate(0.1, theme.box.border)};
    border-radius: 50%;
    width: 12px;
    height: 12px;
    &:after {
      content: ' ';
    }
  }
  > .content {
    margin-left: 15px;
    flex-grow: 1;
  }

  &:hover,
  &.active {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
    > .check-circle {
      border: 1px solid ${({ theme }) => theme.colors.primary};
      background: ${({ theme }) => theme.colors.primary};
      width: 14px;
      height: 14px;
    }
  }

`;
const IconWrapper = styled.div `
  display: flex;
  width: 48px;
  height: 48px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #F1F4F7;
  border-radius: 99px;
`;
const Item = (props) => (React.createElement(ItemComponent, { className: props.active ? 'active' : '', onClick: props.onClick },
    props.icon && React.createElement(IconWrapper, null, props.icon),
    React.createElement("div", { className: "content", style: { flexGrow: 8, alignSelf: 'center' } }, props.children),
    React.createElement(FaPlus, null)));
export class ListSelectMobile extends React.Component {
    render() {
        const { items, selected, onChange } = this.props;
        return (React.createElement(Wrapper, null, items.map((item, i) => (React.createElement(Item, { key: i, active: selected === item.value, onClick: () => onChange(item.value), children: item.render(), icon: item.icon })))));
    }
}
//# sourceMappingURL=index.js.map